import request from '@/utils/http'
export function getSevenRedList (data) {
  return request({
    method: 'POST',
    url: '/rest/sevenRed/querySevenRedProductsList',
    data
  })
}
//  查询红春晚所有合集
export function getRedVideoList () {
  return request({
    method: 'POST',
    url: '/rest/sevenRed/queryRedVideo'
  })
}
// 根据年份查询所有红春晚
export function getYearRedVideoList (data) {
  return request({
    method: 'POST',
    url: '/rest/sevenRed/queryRedVideoList',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/sevenred/index.js